<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_MSG_SEND_MESSAGE from '../../assets/msg-send-message.png';
import IMG_STEP_SEND_MESSAGE from '../../assets/step-send-message.png';

interface Props {
  backgroundImage: string;
  productImage?: string;
  isMsgShow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  productImage: '',
  isMsgShow: true
});
</script>

<template>
<div class="send-message">
  <CarouselMobile
    :mobileFrameImage="IMG_STEP_SEND_MESSAGE"
    :backgroundImage="props.backgroundImage"
    :productImage="props.productImage"
    :msgImage="IMG_MSG_SEND_MESSAGE"
    :isMsgShow="props.isMsgShow"
    :isShowHeaderInfo="true"
  />
</div>
</template>
